// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/Whatsapp/Whatsapp.css */

.whatsapp-scanner-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  left: auto;
  z-index: 1000;
}

.whatsapp-scanner-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 20px;
  width: 300px;
  transition: all 0.3s ease;
}

.whatsapp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.whatsapp-header h2 {
  margin: 0;
  color: #333;
  font-size: 16px;
}

.headerrr-buttons {
  display: flex;
  gap: 5px;
}

.minimize-button {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 5px;
  transition: color 0.2s;
}

.minimize-button:hover {
  color: #e53e3e;
  transform: scale(1.1);
}

.whatsapp-icon-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  left: auto;
  z-index: 1000;
  cursor: pointer;
}

.whatsapp-icon {
  width: 40px;
  height: 40px;
  background-color: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
}

.whatsapp-icon:hover {
  transform: scale(1.1);
}

.whatsapp-icon i {
  color: white;
  font-size: 28px;
}

.whatsapp-minimized {
  position: fixed;
  bottom: 20px;
  right: 20px;
  left: auto;
  width: 50px;
  height: 50px;
  background-color: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
  z-index: 1000;
}

.whatsapp-minimized:hover {
  transform: scale(1.1);
}

.whatsapp-minimized i {
  color: white;
  font-size: 24px;
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 15px 0;
}

.qr-container img {
  width: 200px;
  height: 200px;
  margin-bottom: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
}

.qr-container p {
  color: #666;
  text-align: center;
  font-size: 14px;
  margin: 0;
}

.status-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 5px;
  margin: 10px 0;
  font-size: 14px;
  transition: all 0.3s ease;
}

.status-message i {
  margin-right: 8px;
  font-size: 16px;
}

.status-message.connected {
  background-color: #e7f7ed;
  color: #1f8b4d;
}

.status-message.disconnected {
  background-color: #fde8e8;
  color: #e53e3e;
}

.status-message.reconnecting {
  background-color: #fff8e6;
  color: #b7791f;
}

.error-message {
  background-color: #fde8e8;
  color: #e53e3e;
  padding: 12px;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 14px;
  text-align: center;
}

.refresh-button {
  width: 100%;
  padding: 12px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.refresh-button:hover {
  background-color: #1fba59;
}

.refresh-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.fa-sync {
  animation: spin 1s linear infinite;
}

/* Messages Interface */
.messages-button {
  background: none;
  border: none;
  color: #25d366;
  cursor: pointer;
  padding: 5px;
  transition: all 0.2s;
  font-size: 18px;
}

.messages-button:hover {
  color: #1fba59;
  transform: scale(1.1);
}

.messages-container {
  max-height: 500px;
  overflow-y: auto;
}

.message-stats {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 5px;
  margin-bottom: 15px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.stat-item i {
  color: #25d366;
  font-size: 16px;
}

.messages-content {
  min-height: 300px;
}

/* Conversations List */
.conversations-list h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
}

.no-conversations {
  text-align: center;
  color: #999;
  padding: 40px 20px;
}

.conversation-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background 0.2s;
}

.conversation-item:hover {
  background: #f5f5f5;
}

.conversation-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 12px;
}

.conversation-details {
  flex: 1 1;
}

.conversation-name {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  margin-bottom: 2px;
}

.conversation-phone {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
}

.conversation-count {
  font-size: 11px;
  color: #999;
}

.conversation-time {
  font-size: 11px;
  color: #999;
}

/* Conversation View */
.conversation-view {
  display: flex;
  flex-direction: column;
  height: 400px;
}

.conversation-header {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
  gap: 10px;
}

.back-button {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 5px;
  font-size: 16px;
  transition: color 0.2s;
}

.back-button:hover {
  color: #25d366;
}

.conversation-header h3 {
  margin: 0;
  font-size: 14px;
  color: #333;
}

.messages-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message-item {
  display: flex;
  margin-bottom: 8px;
}

.message-item.incoming {
  justify-content: flex-start;
}

.message-item.outgoing {
  justify-content: flex-end;
}

.message-bubble {
  max-width: 70%;
  padding: 8px 12px;
  border-radius: 8px;
  position: relative;
}

.message-item.incoming .message-bubble {
  background: #f0f0f0;
  color: #333;
}

.message-item.outgoing .message-bubble {
  background: #dcf8c6;
  color: #333;
}

.message-media {
  margin-bottom: 8px;
}

.message-media img {
  max-width: 100%;
  border-radius: 5px;
}

.message-media video {
  max-width: 100%;
  border-radius: 5px;
}

.message-media audio {
  width: 100%;
}

.message-media a {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #25d366;
  text-decoration: none;
  padding: 8px;
  background: white;
  border-radius: 5px;
}

.message-media a:hover {
  background: #f5f5f5;
}

.message-text {
  word-wrap: break-word;
  font-size: 14px;
  line-height: 1.4;
}

.message-time {
  font-size: 10px;
  color: #999;
  margin-top: 4px;
  text-align: right;
}

/* Scrollbar styling */
.messages-container::-webkit-scrollbar,
.messages-list::-webkit-scrollbar {
  width: 6px;
}

.messages-container::-webkit-scrollbar-track,
.messages-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.messages-container::-webkit-scrollbar-thumb,
.messages-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.messages-container::-webkit-scrollbar-thumb:hover,
.messages-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Message input container */
.message-input-container {
  display: flex;
  gap: 10px;
  padding: 15px;
  background: white;
  border-top: 1px solid #e0e0e0;
  border-radius: 0 0 15px 15px;
}

.message-input {
  flex: 1 1;
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 25px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.message-input:focus {
  border-color: #25D366;
}

.message-input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.send-button {
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  background: #25D366;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  font-size: 16px;
}

.send-button:hover:not(:disabled) {
  background: #128C7E;
  transform: scale(1.05);
}

.send-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: scale(1);
}

.send-button i {
  margin: 0;
}

/* Conversations header */
.conversations-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.conversations-header h3 {
  margin: 0;
  font-size: 18px;
  color: #075E54;
}

.new-message-button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: #25D366;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  font-size: 16px;
}

.new-message-button:hover {
  background: #128C7E;
  transform: scale(1.05);
}

/* No conversations state */
.no-conversations {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #666;
}

.start-conversation-button {
  margin-top: 20px;
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  background: #25D366;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.start-conversation-button:hover {
  background: #128C7E;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.modal-content {
  background: white;
  border-radius: 15px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: #075E54;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f5f5f5;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.modal-close:hover {
  background: #e0e0e0;
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-body label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.phone-input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 15px;
  outline: none;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.phone-input:focus {
  border-color: #25D366;
}

.start-chat-button {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background: #25D366;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.start-chat-button:hover:not(:disabled) {
  background: #128C7E;
}

.start-chat-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .whatsapp-scanner-card {
    width: calc(100vw - 40px);
    max-width: 350px;
  }
  
  .conversation-view {
    height: 350px;
  }
  
  .message-input-container {
    padding: 10px;
  }
  
  .send-button {
    width: 40px;
    height: 40px;
  }
  
  .modal-content {
    width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/Whatsapp/Whatsapp.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* src/components/routes/Other/Whatsapp/Whatsapp.css */\n\n.whatsapp-scanner-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  left: auto;\n  z-index: 1000;\n}\n\n.whatsapp-scanner-card {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 20px;\n  width: 300px;\n  transition: all 0.3s ease;\n}\n\n.whatsapp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.whatsapp-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.headerrr-buttons {\n  display: flex;\n  gap: 5px;\n}\n\n.minimize-button {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 5px;\n  transition: color 0.2s;\n}\n\n.minimize-button:hover {\n  color: #e53e3e;\n  transform: scale(1.1);\n}\n\n.whatsapp-icon-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  left: auto;\n  z-index: 1000;\n  cursor: pointer;\n}\n\n.whatsapp-icon {\n  width: 40px;\n  height: 40px;\n  background-color: #25d366;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s;\n}\n\n.whatsapp-icon:hover {\n  transform: scale(1.1);\n}\n\n.whatsapp-icon i {\n  color: white;\n  font-size: 28px;\n}\n\n.whatsapp-minimized {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  left: auto;\n  width: 50px;\n  height: 50px;\n  background-color: #25d366;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s;\n  z-index: 1000;\n}\n\n.whatsapp-minimized:hover {\n  transform: scale(1.1);\n}\n\n.whatsapp-minimized i {\n  color: white;\n  font-size: 24px;\n}\n\n.qr-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 15px 0;\n}\n\n.qr-container img {\n  width: 200px;\n  height: 200px;\n  margin-bottom: 10px;\n  border: 1px solid #eee;\n  border-radius: 5px;\n}\n\n.qr-container p {\n  color: #666;\n  text-align: center;\n  font-size: 14px;\n  margin: 0;\n}\n\n.status-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n  border-radius: 5px;\n  margin: 10px 0;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.status-message i {\n  margin-right: 8px;\n  font-size: 16px;\n}\n\n.status-message.connected {\n  background-color: #e7f7ed;\n  color: #1f8b4d;\n}\n\n.status-message.disconnected {\n  background-color: #fde8e8;\n  color: #e53e3e;\n}\n\n.status-message.reconnecting {\n  background-color: #fff8e6;\n  color: #b7791f;\n}\n\n.error-message {\n  background-color: #fde8e8;\n  color: #e53e3e;\n  padding: 12px;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.refresh-button {\n  width: 100%;\n  padding: 12px;\n  background-color: #25d366;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.refresh-button:hover {\n  background-color: #1fba59;\n}\n\n.refresh-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.fa-sync {\n  animation: spin 1s linear infinite;\n}\n\n/* Messages Interface */\n.messages-button {\n  background: none;\n  border: none;\n  color: #25d366;\n  cursor: pointer;\n  padding: 5px;\n  transition: all 0.2s;\n  font-size: 18px;\n}\n\n.messages-button:hover {\n  color: #1fba59;\n  transform: scale(1.1);\n}\n\n.messages-container {\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.message-stats {\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n  background: #f5f5f5;\n  border-radius: 5px;\n  margin-bottom: 15px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n\n.stat-item i {\n  color: #25d366;\n  font-size: 16px;\n}\n\n.messages-content {\n  min-height: 300px;\n}\n\n/* Conversations List */\n.conversations-list h3 {\n  margin: 0 0 15px 0;\n  font-size: 16px;\n  color: #333;\n}\n\n.no-conversations {\n  text-align: center;\n  color: #999;\n  padding: 40px 20px;\n}\n\n.conversation-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.conversation-item:hover {\n  background: #f5f5f5;\n}\n\n.conversation-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #25d366;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  margin-right: 12px;\n}\n\n.conversation-details {\n  flex: 1;\n}\n\n.conversation-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n  margin-bottom: 2px;\n}\n\n.conversation-phone {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 2px;\n}\n\n.conversation-count {\n  font-size: 11px;\n  color: #999;\n}\n\n.conversation-time {\n  font-size: 11px;\n  color: #999;\n}\n\n/* Conversation View */\n.conversation-view {\n  display: flex;\n  flex-direction: column;\n  height: 400px;\n}\n\n.conversation-header {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  gap: 10px;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 5px;\n  font-size: 16px;\n  transition: color 0.2s;\n}\n\n.back-button:hover {\n  color: #25d366;\n}\n\n.conversation-header h3 {\n  margin: 0;\n  font-size: 14px;\n  color: #333;\n}\n\n.messages-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.message-item {\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.message-item.incoming {\n  justify-content: flex-start;\n}\n\n.message-item.outgoing {\n  justify-content: flex-end;\n}\n\n.message-bubble {\n  max-width: 70%;\n  padding: 8px 12px;\n  border-radius: 8px;\n  position: relative;\n}\n\n.message-item.incoming .message-bubble {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.message-item.outgoing .message-bubble {\n  background: #dcf8c6;\n  color: #333;\n}\n\n.message-media {\n  margin-bottom: 8px;\n}\n\n.message-media img {\n  max-width: 100%;\n  border-radius: 5px;\n}\n\n.message-media video {\n  max-width: 100%;\n  border-radius: 5px;\n}\n\n.message-media audio {\n  width: 100%;\n}\n\n.message-media a {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #25d366;\n  text-decoration: none;\n  padding: 8px;\n  background: white;\n  border-radius: 5px;\n}\n\n.message-media a:hover {\n  background: #f5f5f5;\n}\n\n.message-text {\n  word-wrap: break-word;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.message-time {\n  font-size: 10px;\n  color: #999;\n  margin-top: 4px;\n  text-align: right;\n}\n\n/* Scrollbar styling */\n.messages-container::-webkit-scrollbar,\n.messages-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.messages-container::-webkit-scrollbar-track,\n.messages-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.messages-container::-webkit-scrollbar-thumb,\n.messages-list::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.messages-container::-webkit-scrollbar-thumb:hover,\n.messages-list::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Message input container */\n.message-input-container {\n  display: flex;\n  gap: 10px;\n  padding: 15px;\n  background: white;\n  border-top: 1px solid #e0e0e0;\n  border-radius: 0 0 15px 15px;\n}\n\n.message-input {\n  flex: 1;\n  padding: 12px 15px;\n  border: 1px solid #e0e0e0;\n  border-radius: 25px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.3s;\n}\n\n.message-input:focus {\n  border-color: #25D366;\n}\n\n.message-input:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.send-button {\n  width: 45px;\n  height: 45px;\n  border: none;\n  border-radius: 50%;\n  background: #25D366;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s;\n  font-size: 16px;\n}\n\n.send-button:hover:not(:disabled) {\n  background: #128C7E;\n  transform: scale(1.05);\n}\n\n.send-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: scale(1);\n}\n\n.send-button i {\n  margin: 0;\n}\n\n/* Conversations header */\n.conversations-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.conversations-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #075E54;\n}\n\n.new-message-button {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 50%;\n  background: #25D366;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s;\n  font-size: 16px;\n}\n\n.new-message-button:hover {\n  background: #128C7E;\n  transform: scale(1.05);\n}\n\n/* No conversations state */\n.no-conversations {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  color: #666;\n}\n\n.start-conversation-button {\n  margin-top: 20px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 25px;\n  background: #25D366;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s;\n}\n\n.start-conversation-button:hover {\n  background: #128C7E;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 15px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  color: #075E54;\n}\n\n.modal-close {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  background: #f5f5f5;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s;\n}\n\n.modal-close:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-body label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.phone-input {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 15px;\n  outline: none;\n  transition: border-color 0.3s;\n  box-sizing: border-box;\n}\n\n.phone-input:focus {\n  border-color: #25D366;\n}\n\n.start-chat-button {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 8px;\n  background: #25D366;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.start-chat-button:hover:not(:disabled) {\n  background: #128C7E;\n}\n\n.start-chat-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .whatsapp-scanner-card {\n    width: calc(100vw - 40px);\n    max-width: 350px;\n  }\n  \n  .conversation-view {\n    height: 350px;\n  }\n  \n  .message-input-container {\n    padding: 10px;\n  }\n  \n  .send-button {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .modal-content {\n    width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
